<template lang="pug">
  .password_change
    loading(:active.sync="is_loading")
    h3 本パスワードの登録
    .alert.alert-info(v-if="error == null") 本パスワードを登録してください。
    .alert.alert-danger(v-if="error != null") {{error}}
    .form-group
      input.form-control(type='password' placeholder='パスワード' v-model="pwd1" maxlength="20")
    .form-group
      input.form-control(type='password' placeholder='パスワード(確認)' v-model="pwd2" maxlength="20")
    .form-group
      button.btn.btn-primary(style="width:100%" v-on:click="click_submit") 登録
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import {mapState} from 'vuex'
  import WtHttp from '@/components/WtHttp';

  export default {
    name: 'StudyPasswordChange',
    mixins: [],
    components: {Loading},
    computed: mapState({
      //wt: state => state.wt.user
    }),
    props: [],
    data() {
      return {error:null, pwd1:"", pwd2:"", is_loading:false};
    },
    created() {},
    beforeDestroy() {},
    methods: {
      click_submit(){
        this.error = null
        if(this.pwd1 == "") this.error = "パスワードを入力してください。"
        else if(this.pwd1.length < 6 || !this.pwd1.match(/^[a-zA-Z0-9]+?$/)) this.error = "パスワードは英数字6文字以上で入力してください。"
        else if(20 < this.pwd1.length) this.error = "パスワードは英数字20文字以内で入力してください。"
        else if(this.pwd1 == this.$store.state.wt.user.id) this.error = "学籍番号と同じパスワードは使用できません。"
        else if(this.pwd2 == "") this.error = "パスワード(確認)を入力してください。"
        else if(this.pwd1 != this.pwd2) this.error = "パスワード(確認)が異なっています。"
        else{
          this.is_loading = true
          // 登録処理
          WtHttp.post('./api/study/change_password', {pwd: this.pwd1}).then(
            res => {
              this.$store.commit('wt/user', res.data.user)
              alert("本パスワードの登録が完了しました。")
              this.is_loading = false
              window.location.href = '#/study/Top';
            }, error => {
              alert("パスワードの変更に失敗しました。")
              this.is_loading = false
            }
          )
        }
      }
    },
    watch: {}
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
